import api from './api';

// Planning
export const getPlanning = async (params) => {
  const response = await api.get('/admin/planning', { params });
  return response.data;
};

// Dashboard
export const getDashboardStats = async (params) => {
  const response = await api.get('/admin/dashboard/stats', { params });
  return response.data;
};

// Absences
export const getAbsences = async (params) => {
  const response = await api.get('/admin/absences', { params });
  return response.data;
};
export const createAbsence = async (data) => {
  const response = await api.post('/admin/absences', data);
  return response.data;
};
export const updateAbsence = async (id, data) => {
  const response = await api.put(`/admin/absences/${id}`, data);
  return response.data;
};
export const deleteAbsence = async (id) => {
  const response = await api.delete(`/admin/absences/${id}`);
  return response.data;
};

// Teams
export const getAdminTeams = async () => {
  const response = await api.get('/admin/teams');
  return response.data;
};
export const createTeam = async (data) => {
  const response = await api.post('/admin/teams', data);
  return response.data;
};
export const updateTeam = async (id, data) => {
  const response = await api.put(`/admin/teams/${id}`, data);
  return response.data;
};

// Depots
export const getDepots = async () => {
  const response = await api.get('/admin/depots');
  return response.data;
};
export const createDepot = async (data) => {
  const response = await api.post('/admin/depots', data);
  return response.data;
};
export const updateDepot = async (id, data) => {
  const response = await api.put(`/admin/depots/${id}`, data);
  return response.data;
};
export const deleteDepot = async (id) => {
  const response = await api.delete(`/admin/depots/${id}`);
  return response.data;
};

// Config
export const getConfig = async () => {
  const response = await api.get('/admin/config');
  return response.data;
};
export const updateConfig = async (configs) => {
  const response = await api.put('/admin/config', { configs });
  return response.data;
};

// Analytics
export const getAnalyticsOverview = async (params) => {
  const response = await api.get('/admin/analytics/overview', { params });
  return response.data;
};
export const getAnalyticsTeams = async (params) => {
  const response = await api.get('/admin/analytics/teams', { params });
  return response.data;
};
export const getAnalyticsDaily = async (params) => {
  const response = await api.get('/admin/analytics/daily', { params });
  return response.data;
};
export const getAnalyticsDistances = async (params) => {
  const response = await api.get('/admin/analytics/distances', { params });
  return response.data;
};
export const precomputeDistances = async (data) => {
  const response = await api.post('/admin/analytics/precompute', data);
  return response.data;
};
export const clearAnalyticsCache = async () => {
  const response = await api.delete('/admin/analytics/cache');
  return response.data;
};

// Optimizer
export const analyzeOptimizer = async (date) => {
  const response = await api.get('/admin/optimizer/analyze', { params: { date } });
  return response.data;
};
export const applyOptimizerSuggestion = async (data) => {
  const response = await api.post('/admin/optimizer/apply', data);
  return response.data;
};

// Fiches PDF
export const downloadFicheEquipe = async (equipeId, dateDebut, dateFin) => {
  const response = await api.get(`/admin/fiches/${equipeId}`, {
    params: { date_debut: dateDebut, date_fin: dateFin },
    responseType: 'blob'
  });
  return response.data;
};

// Chat IA
export const sendChatMessage = async (messages) => {
  const response = await api.post('/admin/chat', { messages });
  return response.data;
};
